import { Button } from '../../../../components/button'

export default function Result({ vehicle, onDeny, onConfirm }) {
  return (
    <div className='resultView'>
      <h1 className='title'>Is this your vehicle?</h1>

      <div className='carImage'>
        {!!(
          vehicle?.photoDetails?.stockImageUrl ||
          (vehicle?.builds?.length > 0 && vehicle?.builds[0]?.photoDetails?.stockImageUrl)
        ) && (
          <img
            src={
              vehicle?.photoDetails?.stockImageUrl ||
              vehicle?.builds[0]?.photoDetails?.stockImageUrl
            }
            alt='car'
            width='1440'
            height='810'
          />
        )}
      </div>

      <p className='carName'>{vehicle.vehicleName}</p>

      <p className='vin'>VIN: {vehicle.vin}</p>

      <div className='buttonsContainer'>
        <div className='flex alignCenter justifyCenter'>
          <Button color='secondary' onClick={onDeny}>
            No
          </Button>
          <Button onClick={onConfirm}>Yes</Button>
        </div>
      </div>

      <style jsx>{`
        .resultView {
          max-width: 100vw;
          width: 43.6rem;
          background: var(--primary-bg-color);
        }

        .title {
          padding: 3.4rem 0 0;
          text-align: center;
          font-size: 3.4rem;
        }

        .carImage {
          max-width: 37rem;
          width: 100%;
          height: 23.5rem;
          margin: 0 auto;

          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .carName {
          margin: 0.6rem 0;
          text-align: center;
          color: var(--secondary-text-color);
          font-size: 1.6rem;
          font-weight: 700;
        }

        .vin {
          text-align: center;
          color: var(--secondary-text-color);
          text-transform: uppercase;
          font-size: 1.6rem;
        }

        .buttonsContainer {
          padding: 0 0 6.3rem;
          text-align: center;

          .flex {
            width: 100%;
            margin: 3.3rem 0 1.2rem;

            :global(a),
            :global(button) {
              margin: 0 0.35rem;
            }
          }

          .flatBtn {
            display: inline-block;
            margin: 0 auto;
            color: var(--text-link-color);
            font-size: 1.6rem;
          }
        }

        @media (max-width: 1024px) {
          .resultView {
            max-width: 346px;
            width: 100%;
            margin: 0 auto;
          }

          .title {
            padding: 6rem 0 0;
            font-size: 1.8rem;
          }

          .carImage {
            height: 21.9rem;
          }

          .carName,
          .vin {
            font-size: 1.4rem;
          }

          .vin {
            color: var(--secondary-text-color);
          }

          .buttonsContainer {
            position: fixed;
            left: 0;
            bottom: 2.1rem;
            width: 100%;
            padding: 0 1.2rem;

            .flex {
              margin: 0 0 1.2rem;

              :global(a),
              :global(button) {
                width: 100%;
                margin: 0 0.35rem;
              }

              .flatBtn {
                font-size: 1.4rem;
              }
            }
          }
        }
      `}</style>
    </div>
  )
}
